import { LeftMenuItems, RouteEnum } from "../../../../models/enums";
import { LeftSideBarItem } from "../../UnifiedLayout";

export const PartnerUserItems: LeftSideBarItem[] = [
  {
    name: LeftMenuItems.TELEMETRY,
    path: RouteEnum.Empty,
    nonClickable: true,
    nestedItems: [
      {
        name: LeftMenuItems.TANK_LEVEL,
        path: RouteEnum.SensoryTelemetryTlm,
      },
      {
        name: LeftMenuItems.GATE_GUARD,
        path: RouteEnum.SensoryTelemetryAgg,
      },
      // FEATURE FLAG - PERSONNEL DETECTION. PREVENT NEW FEATURE FROM BEING ENABLED.
      // {
      //   name: LeftMenuItems.PEOPLE_AND_VEHICLE,
      //   path: RouteEnum.SensoryTelemetryPeopleAndVehicle,
      // },
      {
        name: LeftMenuItems.HARD_HAT,
        path: RouteEnum.SensoryTelemetryHardHat,
      },
    ],
  },
  {
    name: LeftMenuItems.CONTROL_ROOM_BETA,
    path: RouteEnum.SensoryControlRoom,
  },
  {
    name: LeftMenuItems.RECENT_ACTIVITIES,
    path: RouteEnum.SensoryRecentActivities,
  },

  {
    name: LeftMenuItems.LIVE_VIEW,
    path: RouteEnum.SensoryLiveView,
  },
  {
    name: LeftMenuItems.DEPLOYMENT_HEALTH,
    path: RouteEnum.SensoryDeploymentHealth,
  },
  {
    name: LeftMenuItems.STATISTICS,
    path: RouteEnum.SensoryStatistics,
    showDivider: true,
  },
  {
    name: LeftMenuItems.SYSTEM_SETTINGS,
    path: RouteEnum.SensorySystemSettings,
    isSeparatorOfBottomSection: true,
  },
];
